export default "__VITE_ASSET__b0F3sWh7__"